/** FAQs for Bank-Grade Security freelancer landing (index-10). */
const freelancerSecurityFaqs = [
  {
    id: "sec-1",
    title: "How does OracleMarket protect my freelancer payouts?",
    desc: "Funds move over encrypted channels, accounts are monitored for unusual activity, and you can enable two-factor authentication so only you can approve withdrawals or changes.",
  },
  {
    id: "sec-2",
    title: "Is my bank or card data stored on your servers?",
    desc: "Sensitive payment credentials are tokenized and processed through PCI-aware partners. OracleMarket never stores full card numbers in plain form.",
  },
  {
    id: "sec-3",
    title: "What happens if someone tries to access my account?",
    desc: "We use device checks, login alerts, and optional step-up verification. You can freeze outbound transfers from the app and contact support immediately.",
  },
  {
    id: "sec-4",
    title: "Are wire and ACH transfers covered by the same protections?",
    desc: "Yes. Every rail—ACH, wire, or wallet transfer—uses verified beneficiary details, audit trails, and compliance screening before money moves.",
  },
  {
    id: "sec-5",
    title: "How do I report suspicious activity?",
    desc: "Use in-app support or your dashboard alert center. Our team reviews reports around the clock and can lock transfers while we investigate.",
  },
  {
    id: "sec-6",
    title: "Does OracleMarket support business-grade compliance?",
    desc: "We maintain KYC/AML workflows, transaction logging for tax and accounting, and configurable approval rules for teams that share one account.",
  },
];

export default freelancerSecurityFaqs;
